import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { REQUIRED_DOC_STATUS } from '../../../constants';
import { getHdEpaDocs } from '../../../components/ProjectManagement/EPALead/services/epa-lead.service';

const initialState = {
  byProjectId: {},
  status: 'idle',
  error: null,
};

export const fetchHdDocData = createAsyncThunk(
  'hdDocs/fetchHdDocData',
  async (projectId, { rejectWithValue }) => {
    try {
      const res = await getHdEpaDocs(projectId);

      const pendingDocs =
        res?.items?.filter(
          doc => doc.document_status === REQUIRED_DOC_STATUS?.PENDING
        ) || [];

      return {
        projectId,
        pendingCount: pendingDocs.length,
      };
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch documents');
    }
  },
  {
    condition: (projectId, { getState }) => {
      const state = getState();

      if (!state.hdDocs) return true;

      return state.hdDocs.byProjectId?.[projectId] === undefined;
    },
  }
);

const hdDocSlice = createSlice({
  name: 'hdDocs',
  initialState,
  reducers: {
    clearHdDocs: state => {
      state.byProjectId = {};
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchHdDocData.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchHdDocData.fulfilled, (state, action) => {
        const { projectId, pendingCount } = action.payload;
        state.status = 'succeeded';
        state.byProjectId[projectId] = pendingCount;
        state.error = null;
      })
      .addCase(fetchHdDocData.rejected, (state, action) => {
        if (action.payload === 'HdDocs already fetched') {
          state.status = 'succeeded';
        } else {
          state.status = 'failed';
          state.error = action.payload || action.error.message;
        }
      });
  },
});

export const { clearHdDocs } = hdDocSlice.actions;
export const hdDocsReducer = hdDocSlice.reducer;
